import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';

import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from "react-router";
import UserCondition from "../UserCondition";

class Footer extends Component {

  render() {
    return (
      <div>
      	<div className="footer-landing">
			<Grid fluid={false}>
				<Row>
					<Col sm={3}>
					<div className="footer-box">
						<h4>Webfinery</h4>
					    <ul className="list-unstyled">
					    	<li><Link to="/home">Home</Link></li>
					    	<UserCondition isLoggedIn={true}>
					    		<li><Link to="/dashboard">Dashboard</Link></li>
					    	</UserCondition>
					    	<UserCondition isLoggedIn={false}>
					    		<li><Link to="/signup" style={{color: 'lightgreen'}}>Sign up</Link></li>
						        <li><Link to="/login">Log in</Link></li>						        
						    </UserCondition>							
							<li><Link to="/search">Search</Link></li>
							<li><Link to="/lists">Lists</Link></li>
							<li><Link to="/cloud">Cloud</Link></li>
							<li><Link to="/consulting">Consulting</Link></li>							
					        <li><a href="https://www.visitrank.com" target="_blank" style={{color: 'yellow'}}>Visit Rank</a></li>
					    </ul>
					</div>
					</Col>				
					<Col sm={3}>
					<div className="footer-box">
						<h4>Contact</h4>
					    <ul className="list-unstyled">
					        <li><a href="mailto:sales@webfinery.com">Sales</a></li>
					        <li><a href="mailto:support@webfinery.com">Support</a></li>
					    </ul>
				    </div>
					</Col>
					<Col sm={3}>
						<div className="footer-box">
							<h4>Legal</h4>
						    <ul className="list-unstyled">
						        <li><Link to="/terms">Terms</Link></li>
						        <li><Link to="/privacy">Privacy</Link></li>
						    </ul>
						</div>
					</Col>
					<Col sm={3}>
					<div className="footer-box">
						<div className="logo">Webfinery</div>
					    <ul className="list-unstyled">
					        <li><small>By Mint Rock Ltd.</small></li>
					        <li><small>&copy; All Rights Reserved</small></li>
					    </ul>
					 </div>
					</Col>					
				</Row>		
			</Grid>
		</div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/content/Footer.js